<template>
<v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="4" class="pa-2 pt-0" v-if="currentUser.team && currentUser.team.teamId">
        <TeamWidget :teamId="currentUser.team.teamId"></TeamWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0" v-if="userHasRole('ROLE_EVENTING_DATA') && (currentUser.team && currentUser.team.teamId)">
        <LastGameWidget :teamId="currentUser.team.teamId"></LastGameWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0" v-if="currentUser.team && currentUser.team.teamId">
        <NextGameWidget :teamId="currentUser.team.teamId"></NextGameWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" @mouseenter="cycling(false)" @mouseleave="cycling(true)" v-if="currentUser.team && currentUser.team.seasonId">
        <v-carousel :cycle="cycle" hide-delimiters height="auto" class="elevation-2"
          show-arrows-on-hover
          :light="!$vuetify.theme.dark">
          <v-carousel-item>
            <LastMatchdayGamesWidget
              :seasonId="currentUser.team.seasonId"
              @heightChange="lastMatchdayGameHeight = $event ? $event : lastMatchdayGameHeight"
            ></LastMatchdayGamesWidget>
          </v-carousel-item>
          <v-carousel-item>
            <NextMatchdayGamesWidget
              :seasonId="currentUser.team.seasonId"
              @heightChange="lastMatchdayGameHeight = $event ? $event : lastMatchdayGameHeight"
            ></NextMatchdayGamesWidget>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <LastPlayersSearch v-bind:style="{'height':lastMatchdayGameHeight+'px'}"></LastPlayersSearch>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['npgVsXGChart','xGAgainstvsNPGAgainstChart','pointsVsXPointsChart']"
          @heightChange="charts1Height=$event"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <FavoritesWidget
          :userId="currentUser.id"
          v-bind:style="{'height':charts1Height+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['xGvsxGAgainstChart']"
          @heightChange="charts2Height=$event"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CollectionsWidget v-bind:style="{'height':charts2Height+'px'}"></CollectionsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TeamWidget from "./widgets/TeamWidget";
import LastGameWidget from "./widgets/LastGameWidget";
import NextGameWidget from "./widgets/NextGameWidget";
import LastMatchdayGamesWidget from "./widgets/LastMatchdayGamesWidget";
import NextMatchdayGamesWidget from "./widgets/NextMatchdayGamesWidget";
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import ChartsWidget from "./widgets/ChartsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import { userHasRole } from "../../utils/functions";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "ScoutDashboard",
  components: {
    TeamWidget,
    LastGameWidget,
    NextGameWidget,
    LastMatchdayGamesWidget,
    FavoritesWidget,
    CollectionsWidget,
    ChartsWidget,
    LastPlayersSearch,
    NextMatchdayGamesWidget,
    LastScoutingAnalysesWidget,
    ScoutingTasksWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  props: {},
  data() {
    return {
      loading: false,
      lastMatchdayGameHeight: null,
      charts1Height: null,
      charts2Height: null,
      cycle: true
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    cycling(cycle){
      this.cycle = cycle;
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>
